const mutations = {
  SERVICE_TITAN_CHANGE_VALUE: (state, payload) => {
    const {
      field,
      value,
    } = payload;
    state[field] = value;
  },
  SERVICE_TITAN_CHANGE_VALUES: (state, payload) => {
    const {
      changes,
    } = payload;
    changes.forEach((change) => {
      const {
        field,
        value,
      } = change;
      state[field] = value;
    });
  },
};
export default mutations;
